import Vue from 'vue'
import App from './views/App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueWechatTitle from 'vue-wechat-title';
import * as api from './api'
import Tools from '@/tools'

Vue.prototype.$api = api;
Vue.use(api);
Vue.use(VueWechatTitle)
Vue.use(ElementUI);

Vue.use(Tools)
// 为了解决setItemEvent不立即生效，使用事件派发强制更高
Tools.dispatchEventStroage()
// Tools.dispatchEventRemove()
// 监听localStorage值
Vue.prototype.$addStorageEvent = function (key, data) {
	// 创建一个StorageEvent事件
	var newStorageEvent = document.createEvent('StorageEvent');
	const storage = {
		setItem: function (k, val) {
			// console.log(k, val)
			localStorage.setItem(k, val);
			// 初始化创建的事件
			newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
			// 派发对象
			window.dispatchEvent(newStorageEvent);
		}
	}
	return storage.setItem(key, data);
}

// Vue.prototype.$addLocalStorageEvent = function (key, data) {
// 	// 创建一个StorageEvent事件
// 	var localStorageEvent = document.createEvent('StorageEvent');
// 	const storage = {
// 		setItem: function (k, val) {
// 			// console.log(k, val)
// 			localStorage.setItem(k, val);
// 			// 初始化创建的事件
// 			localStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
// 			// 派发对象
// 			window.dispatchEvent(localStorageEvent);
// 		}
// 	}
// 	return storage.setItem(key, data);
// }
// 跳转页面后回到顶部
router.beforeEach((to, from, next) => {
	// console.log(to, from)
	if (from.name === 'deal' && to.name === 'deal') {
		next()
	} else if (from.name === 'help' && to.name === 'help') {
		next()
	} else if (from.name === 'auction' && to.name === 'auction') {
		if(from.params.type === '0' && to.params.type === '0'){
			next()
		}else if(from.params.type === '1' && to.params.type === '1'){
			next()
		}else{
			document.body.scrollTop = 0
			// firefox
			document.documentElement.scrollTop = 0
			// safari
			window.pageYOffset = 0
			next()
		}
	} else {
		document.body.scrollTop = 0
		// firefox
		document.documentElement.scrollTop = 0
		// safari
		window.pageYOffset = 0
		next()
	}
	// console.log(to, from, next)
})
router.beforeEach((to, from, next) => {

	// document.title = to.meta.title ? to.meta.title : defaultTitle
	if (to.meta.title) {
		document.title = '嘉联华 ' + to.meta.title
	}
	next()
})
Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
